export default __webpack_public_path__ + "static/media/he-extended-fig-1.b2eaf9a6.png";